'use client';

import type { DelayedQuote } from '@benzinga/quotes-manager';
import { SidebarList } from './SidebarList';
import { QuoteCard } from './QuoteCard';

interface StockMarketsSideWidgetProps {
  indices: DelayedQuote[];
}

export function StockMarketsSideWidget({ indices }: StockMarketsSideWidgetProps) {
  if (indices.length === 0) return null;

  return (
    <SidebarList action="/markets" title="Stock Markets">
      {indices.map((ticker, index) => (
        <QuoteCard key={`stock-index-${ticker.symbol ?? index}`} showLogo ticker={ticker} variant="list" />
      ))}
    </SidebarList>
  );
}

export default StockMarketsSideWidget;
